<template>
    <div>
        <v-data-table
                class="custom-table custom-table__header"
                :headers="data.headers"
                :items="data.body"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                :custom-filter="filterTableData"
                hide-default-footer
                :loading="loading"
        >
            <template v-slot:top>
                <v-row class="align-center" >
                    <v-col cols="12" >
                        <v-text-field
                            v-model="search"
                            label="Search"
                            @change="onChangeSearch"
                    ></v-text-field>
                    </v-col>
                </v-row>
            </template>
            <template v-if="type === 'compliance'" v-slot:header.action="{ header }">
                {{ header.text }}
                <v-btn v-if="data.body.length" icon :loading="isLoadingDownloadMultipleCsvScan">
                    <v-icon small @click="() => downloadMultipleCsvScan(data.body)">
                        mdi-tray-arrow-down
                    </v-icon>
                </v-btn>
            </template>
            <template v-slot:item.created_at="{ item }">
                <div class="mr-2">
                    {{ item.created_at | convertDate }}
                </div>
            </template>
            <template v-slot:item.type="{ item }">
                <div class="mr-2">
                    {{ item.type | capitalize }}
                </div>
            </template>
            <template v-slot:item.action="{ item }">
                <v-btn icon v-if="type === 'performance.scheduled' ?
                                    (item.type === 'performance'  ? scheduledPerformanceEdit :  scheduledAdsEdit)
                                    : (type === 'performance.realtime' ?
                                            (item.type === 'performance'  ? realtimePerformanceEdit :  realtimeAdsEdit)
                                                : complianceEdit)">
                    <v-icon small @click="editItem(item, routerName)">
                        mdi-content-copy
                    </v-icon>
                </v-btn>
                <v-btn icon v-if="type === 'performance.scheduled' ?
                                    (item.type === 'performance'  ? scheduledPerformanceEdit :  scheduledAdsEdit)
                                    : (type === 'performance.realtime' ?
                                            (item.type === 'performance'  ? realtimePerformanceEdit :  realtimeAdsEdit)
                                                : complianceEdit)">
                    <v-icon small @click="editItem(item, routerName)">
                        mdi-pencil
                    </v-icon>
                </v-btn>
                <v-btn icon v-if="type === 'performance.scheduled' ?
                                    (item.type === 'performance'  ? scheduledPerformanceEdit :  scheduledAdsEdit)
                                    : (type === 'performance.realtime' ?
                                            (item.type === 'performance'  ? realtimePerformanceEdit :  realtimeAdsEdit)
                                                : complianceEdit)">
                    <v-icon small @click="() => handleDeleteScan(item)">
                        mdi-close
                    </v-icon>
                </v-btn>
                <v-btn icon v-if="canBeScanned && item.state === 'DISABLED' &&
                            (type === 'performance.scheduled' ? (item.type === 'performance'  ? scheduledPerformanceEdit :  scheduledAdsEdit)
                                    : (type === 'performance.realtime' ? (item.type === 'performance'  ? realtimePerformanceEdit :  realtimeAdsEdit) : false))">
                    <v-icon small @click="startScan(item)">
                        mdi-play
                    </v-icon>
                </v-btn>
                <v-btn icon v-if="canBeScanned && item.state === 'ENABLED' &&
                            (type === 'performance.scheduled' ? (item.type === 'performance'  ? scheduledPerformanceEdit :  scheduledAdsEdit)
                                    : (type === 'performance.realtime' ? (item.type === 'performance'  ? realtimePerformanceEdit :  realtimeAdsEdit) : false))">
                    <v-icon small @click="stopScan(item)">
                        mdi-stop
                    </v-icon>
                </v-btn>
    <!--            for scenario scan-->
                <v-btn icon v-if="canBeScanned && !item.enabled && !item.state && (type === 'compliance' ?  complianceEdit : false)">
                    <v-icon small @click="startScan(item)">
                        mdi-play
                    </v-icon>
                </v-btn>
                <v-btn icon v-if="canBeScanned && item.enabled && (type === 'compliance' ?  complianceEdit : false)">
                    <v-icon small @click="stopScan(item)">
                        mdi-stop
                    </v-icon>
                </v-btn>

                <v-btn icon v-if="type === 'compliance' ">
                    <v-icon small @click="() => downloadCsvScan(item)">
                        mdi-tray-arrow-down
                    </v-icon>
                </v-btn>
            </template>
            <template v-slot:item.browser="{ item }">
                <div class="mr-2">
                    {{ item.device.device }}
                </div>
            </template>
        </v-data-table>
        <v-row class="align-center" v-if="data.body.length">
            <v-col cols="12" sm="11" >
                <v-pagination
                        v-model="page"
                        :length="Math.ceil(data.totalCount/itemsPerPage)"
                        :total-visible="7"
                        @input="onChangePagination"
                ></v-pagination>
            </v-col>
            <v-col cols="12" sm="1">
                <v-select
                        :value="10"
                        :items="[5, 10, 15, 'All']"
                        label="Items per page"
                        @change="handleItemsPerPage"
                        hint="Items per page"
                        persistent-hint
                ></v-select>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    const authHelper = createNamespacedHelpers("auth");
    const scanListHelper = createNamespacedHelpers("scanList");
    import scanListApi from "../../api/scanList";
    export default {
        data () {
            return {
                search:'',
                page: 1,
                pageCount: 0,
                itemsPerPage: 10,
                isLoadingDownloadMultipleCsvScan: false
            }
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            canBeScanned: {
                type: Boolean,
                default: false
            },
            complianceEdit: {
                type: Boolean,
                default: false
            },
            scheduledPerformanceEdit: {
                type: Boolean,
                default: false
            },
            scheduledAdsEdit: {
                type: Boolean,
                default: false
            },
            realtimePerformanceEdit: {
                type: Boolean,
                default: false
            },
            realtimeAdsEdit: {
                type: Boolean,
                default: false
            },
            routerName: {
                type: String,
                required: false
            },
            domainType: {
                type: String,
                required: false
            },
            selectedScan: {
                type: String,
                required: false
            },
            permissions: {
                type: Array,
                required: false
            },
            type: {
                type: String,
                required: false
            },
            loading: {
                type: Boolean,
                default: false
            },
        },
        filters: {
            capitalize(value) {
                if (!value) return "N/A";
                switch (value) {
                    case "realtime-new-browser":
                        return (value = "New Browser");
                    case "realtime-old-browser":
                        return (value = "Old Browser");
                    case "realtime-with-vnc-new-browser":
                        return (value = "New Browser");
                    case "realtime-with-vnc-old-browser":
                        return (value = "Old Browser");
                    default:
                        return value.charAt(0).toUpperCase() + value.slice(1);
                }
            },
            convertDate(value) {
                if (!value) return "-";
                return value.split("T")[0];
            }
        },
        computed: {
            ...authHelper.mapGetters(["getSelectedClient", "getSelectedClientName"])
        },
        methods: {
            ...scanListHelper.mapActions(["performanceScanStart", "performanceScanStop", "deleteScheduledScan", "deleteScenarioScan",  "stopScenarioScan", "fetchScanListTableData"]),
            editItem(item, routerName) {
                this.$router.push({
                    name: routerName ,
                    params: { scanId: item.id }
                });
            },
            async startScan(item) {
                if(this.domainType === 'scenario'){
                    await this.stopScenarioScan(
                        Object.assign (
                            {id: item.id},
                            {status: {"enabled": true}}
                        )
                    );
                    await this.fetchScanListTableData(this.getSelectedClient);
                } else {
                    await this.performanceScanStart(item.id)
                }
            },
            async stopScan(item) {
                if(this.domainType === 'scenario'){
                    await this.stopScenarioScan(
                        Object.assign (
                            {id: item.id},
                            {status: {"enabled": false}}
                        )
                    );
                    await this.fetchScanListTableData(this.getSelectedClient);
                } else {
                    await this.performanceScanStop(item.id)
                }

            },
            async downloadCsvScan(item) {
                if(this.domainType === 'scenario'){
                    await scanListApi.downloadCsvScan(item.website.id, item.id)
                        .then((blob) => {
                            // Create blob link to download
                            const url = window.URL.createObjectURL(
                                new Blob([blob], { type: 'text/csv;charset=utf-8;' }),
                            );
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute( 'download', `${item.website.name}_scans.csv`);

                            // Append to html link element page
                            document.body.appendChild(link);

                            // Start download
                            link.click();

                            // Clean up and remove the link
                            link.parentNode.removeChild(link);
                        })
                        .catch((err) => {
                            //eslint-disable-next-line
                            console.log(err);
                            alert(err.response ? ('Export Error: status ' + err.response.status) : err);
                        });
                }
            },
            async downloadMultipleCsvScan(data) {
                let websitesIds = [];
                data.map(scanData =>{
                    websitesIds.push(scanData.website.id)
                });
                let uniqueWebsitesId = websitesIds.filter(function(item, pos, self) {
                    return self.indexOf(item) == pos;
                });
                if(this.domainType === 'scenario'){
                    this.isLoadingDownloadMultipleCsvScan = true;
                    await scanListApi.downloadMultipleCsvScan(uniqueWebsitesId.join())
                        .then((blob) => {
                            // Create blob link to download
                            const url = window.URL.createObjectURL(
                                new Blob([blob], { type: 'text/csv;charset=utf-8;' }),
                            );
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', `${this.getSelectedClientName}_scans_multiple.csv`);

                            // Append to html link element page
                            document.body.appendChild(link);

                            // Start download
                            link.click();

                            // Clean up and remove the link
                            link.parentNode.removeChild(link);
                        })
                        .catch((err) => {
                            //eslint-disable-next-line
                            console.log(err);
                            alert(err.response ? ('Export Error: status ' + err.response.status) : err);
                        });
                    this.isLoadingDownloadMultipleCsvScan = false;
                }
            },
            async downloadZipScan(data) {
                let websitesIds = [];
                data.map(scanData =>{
                    websitesIds.push(scanData.website.id)
                });
                let uniqueWebsitesId = websitesIds.filter(function(item, pos, self) {
                    return self.indexOf(item) == pos;
                });
                if(this.domainType === 'scenario'){
                    await scanListApi.downloadZipScan(uniqueWebsitesId.join())
                        .then((zip_string) => {
                            let link = document.createElement('a');
                            link.setAttribute('href', 'data:text/plain;base64,' + zip_string);
                            link.setAttribute('download', `${this.getSelectedClientName}_scans.zip`);

                            link.style.display = 'none';
                            document.body.appendChild(link);

                            link.click();

                            document.body.removeChild(link);
                        })
                        .catch((err) => {
                            //eslint-disable-next-line
                            console.log(err);
                            alert(err.response ? ('Export Error: status ' + err.response.status) : err);
                        });
                }
            },
            async handleDeleteScan(item) {
                this.$emit('delete-scan', item, this.domainType);
            },
            async handleItemsPerPage(itemsPerPage) {
                this.page = 1;
                this.itemsPerPage = itemsPerPage === 'All' ? this.data.totalCount : itemsPerPage;
                this.$emit('change-items-per-page', itemsPerPage, this.type, this.page, this.search );
            },
            filterTableData (value, search) {
                this.page = 1;
                return value != null && search != null && typeof value === 'string' &&
                    value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
            },
            onChangePagination(page){
                this.page = page;
                this.$emit('change-pagination', this.itemsPerPage, this.type, page, this.search);
            },
            onChangeSearch(search){
                this.search = search;
                this.page = 1;
                this.$emit('change-search', this.itemsPerPage, this.type, this.page, search);
            },
        },
    };
</script>
